import { Action } from './index';
import { InviteUserModel } from '../../../dashboard/profile/models/invite-user.model';

export class UpdateUsersAction implements Action {
  static readonly type = '[UserManagement] Invite New Users';

  constructor(public payload: InviteUserModel[]) {}
}
